import React from 'react'
import { CreateRuleFlowProvider } from './context/CreateRuleFlowProvider'
import { CreateRuleFlowMain } from './components/CreateRuleFlowMain'

export const CreateRuleFlow = () => {
  return (
    <CreateRuleFlowProvider>
      <CreateRuleFlowMain />
    </CreateRuleFlowProvider>
  )
}
